import { LocalDate } from '../../../utilities/local-date';
import type { EmployeeForStaffingCalendar } from './employee-for-staffing-calendar';
import type { WorkScheduleException } from '@trinnvis/dabih-api-client';

/**
 * Returns schedule exception for day if it exists
 */
export function getScheduleException(
  day: LocalDate,
  employee: EmployeeForStaffingCalendar,
): WorkScheduleException | undefined {
  if (day && employee.workScheduleExceptions && employee.workScheduleExceptions.length) {
    const exception = employee.workScheduleExceptions.filter((ex) => {
      return day.isSame(LocalDate.fromString(ex.date));
    });
    if (exception.length) {
      return exception[0];
    }
    return undefined;
  }
  return undefined;
}
